import styled, { css } from 'styled-components';

const Title = styled.div.withConfig({
    displayName: "styled__Title",
    componentId: "sc-c9c8c380-0"
})`
    ${({ theme , typography  })=>css(theme.typography[typography])};
    min-height: ${({ minHeight  })=>minHeight}px;
`;

export { Title };
